import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = { class: "flex md:items-end justify-between md:flex-row flex-col" }
const _hoisted_3 = { class: "flex space-x-3 md:mt-0 mt-4" }
const _hoisted_4 = { class: "font-semibold text-sm text-white py-2.5 px-3 rounded bg-red-600" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Past Due Count: ", -1)
const _hoisted_6 = { class: "font-semibold text-sm text-white py-2.5 px-3 rounded bg-green-600" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Scheduled Count: ", -1)
const _hoisted_8 = { class: "grid grid-cols-5 gap-6 mt-6" }
const _hoisted_9 = { class: "xl:col-span-1 lg:col-span-2 col-span-5" }
const _hoisted_10 = { class: "border rounded-lg border-neutral-100" }
const _hoisted_11 = { class: "p-4" }
const _hoisted_12 = { class: "text-xs font-bold" }
const _hoisted_13 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "w-full px-6 border-t py-7" }
const _hoisted_17 = { class: "xl:col-span-4 lg:col-span-3 col-span-5 border rounded-lg border-neutral-100" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-4 border-b border-neutral-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold" }, "Interventions")
], -1)
const _hoisted_19 = { class: "flex lg:items-center lg:justify-between p-4 lg:overflow-auto border-b border-neutral-100 side-scroll lg:flex-row flex-col" }
const _hoisted_20 = { class: "flex items-center pr-4 space-x-1 shrink-0" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "pr-2 text-xs font-bold" }, "Legend: ", -1)
const _hoisted_22 = { class: "flex items-center space-x-1 dashboard_tabs lg:overflow-visible overflow-auto side-scroll lg:mt-0 mt-4 lg:pb-0 pb-2" }
const _hoisted_23 = { class: "p-4 border-b border-neutral-100" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium" }, "All Records", -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "space-y-5" }
const _hoisted_28 = { class: "flex flex-col space-y-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-medium" }, "Intervention", -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_32 = { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_33 = { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_34 = { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "px-6 py-4 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_37 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_38 = { class: "w-full px-6 border-t py-7" }

import { ref, onMounted, computed, watch } from 'vue';
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import DataTable from '@/components/partials/DataTable.vue';
import EditButton from '@/components/buttons/EditButton.vue';
import TabComponent from '@/components/partials/TabComponent.vue';
import FilterPanel from '@/components/partials/FilterPanel.vue';
import DatePicker from "@/components/inputs/DatePicker.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";

import PageLoader from "@/components/loaders/PageLoader.vue";
import InterventionDashboard from "@/classes/Dashboard/InterventionDashboard";
import assignValues from '@/helpers/assignValues';
import SimplePagination from "@/components/partials/SimplePagination.vue";
import { InterventionType } from "@/views/enums/InterventionType";
import { Legend } from '../enums/Legend';
import { useSecurityFeature } from '@/store/securityFeature';
import { onIonViewWillEnter } from '@ionic/vue';
import { useNetworkStore } from '@/store/network';
import Storage from "@/helpers/storage";
import { RoleTypes } from "../enums/RoleTypes";
import http from "@/axios";

interface ItemsData {
    [key: string]: any;
    data: {
        [key: string]: any;
    }
}

interface SelectInterface {
    id: number;
    label: string;
    value: string;
}

interface PaginateParams {
    page: number;
    rows: number;
}

/**--------------------------
 * CONST
----------------------------*/

export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPageWcpu',
  setup(__props) {

const legendOption = ref<Array<any>>([]);				

const personnelOptions = ref<Array<any>>([]);
/**--------------------------
 * INTERFACES
----------------------------*/
const tokens = new Storage();
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const showFilter = ref(false);
const loading = ref(false);
const itemsCount = ref({
    allItemsCount: 0,
    socialWorkCount: 0,
    medicalCount: 0,
    mentalHealthCount: 0,
    developmentalPediaCount: 0,
    legalCount: 0,
    teleconsultationCount: 0,
    telepsychiatryCount: 0,
    adminCount: 0,
    pastDueCount: 0,
    scheduledCount: 0,
    noDiagnosisPatientsCount: 0,
});
const filters = ref({
    filterScheduleDate: null,
    filterSocialWork: false,
    filterMedical: false,
    filterMentalHealth: false,
    filterDevelopmentalPedia: false,
    filterLegal: false,
    filterTeleconsultation: false,
    filterTelepsychiatry: false,
    filterAdmin: false, 
    tab: null as unknown as string,
    interventionType: null,
    filterLegend : null,
    filterPersonnel: null,
});
const typeOptions = ref<SelectInterface[]>([])
const items = ref<ItemsData>({
    data: {}
});
const noDiagnosisPatients = ref<ItemsData>({
    data: {}
});
const filterDiagnosis = ref({});
const tabs = computed(() => [
    { name: 'All', count: itemsCount.value.allItemsCount, tab: null, allowed: true },
    { name: 'Social Work', count: itemsCount.value.socialWorkCount, tab: 'socialWork', allowed: true },
    { name: 'Medical', count: itemsCount.value.medicalCount, tab: 'medical', allowed: true },
    { name: 'Mental Health', count: itemsCount.value.mentalHealthCount, tab: 'mentalHealth', allowed: true },
    { name: 'Developmental Pedia', count: itemsCount.value.developmentalPediaCount, tab: 'developmentalPedia', allowed: true },
    { name: 'Legal', count: itemsCount.value.legalCount, tab: 'legal', allowed: true },
    { name: 'Teleconsultation', count: itemsCount.value.teleconsultationCount, tab: 'teleconsultation', allowed: true },
    { name: 'Telepsychiatry', count: itemsCount.value.telepsychiatryCount, tab: 'telepsychiatry', allowed: true },
    { name: 'Admin', count: itemsCount.value.adminCount, tab: 'admin', allowed: true }
]);

const headers = computed(() => [
    { text: "#" }, 
    { text: "Name" }
]);

const interventionHeaders = computed(() => [
    { text: 'Schedule Date/Time', haveSort: true },
    { text: 'Intervention', haveSort: true },
    { text: 'Type', haveSort: true },
    { text: 'Patient Name', haveSort: true },
]);

/**--------------------------
 * METHODS
----------------------------*/

const getData =(value?:any)=> {
    loading.value = true;
    InterventionDashboard.index(value)
        .then(({data}) => {
            items.value = data?.items ?? { data: [] };
            typeOptions.value = data.typeOptions;
 
            itemsCount.value = assignValues(itemsCount.value, data);
            legendOption.value = data.legends;
            personnelOptions.value = data.personnelOptions;
            filters.value = assignValues(filters.value, data);
        })
        .finally(() => {
            loading.value = false;
            showFilter.value = false;
        });
}

const getPrimaryDiagData =(value?:any) => {
    loading.value = true;
    InterventionDashboard.index(value)
        .then(({data}) => { 
            noDiagnosisPatients.value = data?.noDiagnosisPatients ?? { data: [] };
            filterDiagnosis.value = assignValues(filterDiagnosis.value, data);
        })
        .finally(()=>{
            loading.value = false;
            showFilter.value = false;
        })
}
//Added Filter from Legend
const filterScheduled = () => { 
    filters.value.filterLegend = Legend.Scheduled;//legendOption Scheduled
    getData(filters.value);
}
const filterPastDue = () => {
    filters.value.filterLegend = Legend.Past_Due; //legendOption Past Due
    getData(filters.value);
}

const paginate = ({ page, rows }: PaginateParams): void => {
    filters.value = Object.assign(filters.value, {
        page, rows
    })
    getData(filters.value); 
};

const paginatePrimaryDiagnosis = ({page,rows}: PaginateParams): void => {
    filterDiagnosis.value = Object.assign(filterDiagnosis.value,{
        page,rows 
    }); 
    getPrimaryDiagData(filterDiagnosis.value); 
}

const checkHasPasswordBlocker = () => {
    const item = sessionStorage.getItem('hasPasswordBlocker');
    if (!item) {
        useSecurityFeature().isActivated = false;
        useSecurityFeature().isPasswordBlocker = true;
        sessionStorage.setItem('hasPasswordBlocker', true);
    }
}

const checkRoles = () => {
    const user = JSON.parse(tokens.get("user"));
    const wcpuRoles = [
        RoleTypes.OFFICE_ADMIN,
        RoleTypes.OFFICE_NORMAL,
        RoleTypes.NURSE,
        RoleTypes.WCPU,
        RoleTypes.OFFICE_TRAINEE,
    ]

    if(!wcpuRoles.includes(user.role_id)){
        window.location.href = "/dashboard";
    }
}

const handlePatientSearch = async (value: string = null) => {

    if (!value && filters.value.filterPersonnel) {
        return;
    }

    const response = await http.get(`/intervention-dashboard/personnels`, { params: {
        search: value
    } });

    if (response.status === 200) {
        personnelOptions.value = response.data;
    }
}

/**--------------------------
 * WATCH
----------------------------*/
watch(
    () => filters.value.tab,
    () => {
        getData(filters.value);
    }
)

onMounted(()=>{
    checkRoles();
    getData();
    getPrimaryDiagData(); 
});

onIonViewWillEnter(() => {
    if (isNetworkAvailable.value) {
        checkHasPasswordBlocker();
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SectionTitle, {
            title: "Dashboard",
            description: "View the data analytics in the system."
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", null, _toDisplayString(itemsCount.value.pastDueCount), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(itemsCount.value.scheduledCount), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, "Patient with no Primary Diagnosis: " + _toDisplayString(itemsCount.value.noDiagnosisPatientsCount), 1)
              ]),
              _createVNode(DataTable, {
                headers: headers.value,
                "no-action": true,
                count: noDiagnosisPatients.value.data.length,
                tableClass: "header-frm-table",
                dataTableClass: "border-0"
              }, {
                body: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noDiagnosisPatients.value.data, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: item }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(index+1), 1),
                      _createElementVNode("td", _hoisted_14, [
                        _createElementVNode("a", {
                          href: `/patient/${item?.patient_id}/view`,
                          class: "transition cursor-pointer text-primary-600 hover:text-primary-800"
                        }, _toDisplayString(item.name), 9, _hoisted_15)
                      ])
                    ]))
                  }), 128))
                ]),
                tfoot: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(SimplePagination, {
                      "show-rows": true,
                      numRows: filterDiagnosis.value.rows ?? 10,
                      currentPage: noDiagnosisPatients.value.current_page,
                      "last-page": noDiagnosisPatients.value.last_page,
                      onUpdate: _cache[0] || (_cache[0] = (value) => paginatePrimaryDiagnosis(value))
                    }, null, 8, ["numRows", "currentPage", "last-page"])
                  ])
                ]),
                _: 1
              }, 8, ["headers", "count"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", {
                  class: "rounded px-1 py-0.5 font-semibold text-xs text-white bg-red-600 cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (filterPastDue()))
                }, "Past Due"),
                _createElementVNode("span", {
                  class: "rounded px-1 py-0.5 font-semibold text-xs text-white bg-green-600 cursor-pointer",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (filterScheduled()))
                }, "Scheduled")
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(TabComponent, {
                  tabs: tabs.value,
                  typeThree: "",
                  "active-tab": filters.value.tab,
                  "onUpdate:tab": _cache[3] || (_cache[3] = (value) => filters.value.tab = value)
                }, null, 8, ["tabs", "active-tab"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                type: "button",
                class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 hover:bg-primary-100 w-max",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showFilter.value = true))
              }, _hoisted_26),
              _createVNode(FilterPanel, {
                show: showFilter.value,
                onClose: _cache[16] || (_cache[16] = ($event: any) => (showFilter.value = false)),
                "onApply:reset": getData,
                "onApply:filters": _cache[17] || (_cache[17] = ($event: any) => (getData(filters.value)))
              }, {
                fields: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(MultiSelect, {
                      options: personnelOptions.value,
                      label: "Personnels",
                      id: "personnel",
                      name: "personnel",
                      placeholder: "Select..",
                      modelValue: filters.value.filterPersonnel,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.filterPersonnel) = $event)),
                      searchable: "",
                      "onHandle:search": handlePatientSearch
                    }, null, 8, ["options", "modelValue"]),
                    _createVNode(DatePicker, {
                      label: "Schedule Date/Time",
                      placehlder: "Schedule Date/Time",
                      range: true,
                      modelValue: filters.value.filterScheduleDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.filterScheduleDate) = $event))
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(CheckboxInput, {
                        id: "social_work",
                        name: "social_work",
                        label: "Social Work",
                        checked: filters.value.filterSocialWork,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = (checked) => filters.value.filterSocialWork = checked)
                      }, null, 8, ["checked"]),
                      _createVNode(CheckboxInput, {
                        id: "medical",
                        name: "medical",
                        label: "Medical",
                        checked: filters.value.filterMedical,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = (checked) => filters.value.filterMedical = checked)
                      }, null, 8, ["checked"]),
                      _createVNode(CheckboxInput, {
                        id: "mental_health",
                        name: "mental_health",
                        label: "Mental Health",
                        checked: filters.value.filterMentalHealth,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = (checked) => filters.value.filterMentalHealth = checked)
                      }, null, 8, ["checked"]),
                      _createVNode(CheckboxInput, {
                        id: "developmental_pedia",
                        name: "developmental_pedia",
                        label: "Developmental Pedia",
                        checked: filters.value.filterDevelopmentalPedia,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = (checked) => filters.value.filterDevelopmentalPedia = checked)
                      }, null, 8, ["checked"]),
                      _createVNode(CheckboxInput, {
                        id: "legal",
                        name: "legal",
                        label: "Legal",
                        checked: filters.value.filterLegal,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = (checked) => filters.value.filterLegal = checked)
                      }, null, 8, ["checked"]),
                      _createVNode(CheckboxInput, {
                        id: "teleconsultation",
                        name: "teleconsultation",
                        label: "Teleconsultation",
                        checked: filters.value.filterTeleconsultation,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = (checked) => filters.value.filterTeleconsultation = checked)
                      }, null, 8, ["checked"]),
                      _createVNode(CheckboxInput, {
                        id: "telepsychiatry",
                        name: "telepsychiatry",
                        label: "Telepsychiatry",
                        checked: filters.value.filterTelepsychiatry,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = (checked) => filters.value.filterTelepsychiatry = checked)
                      }, null, 8, ["checked"]),
                      _createVNode(CheckboxInput, {
                        id: "admin",
                        name: "admin",
                        label: "Admin",
                        checked: filters.value.filterAdmin,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = (checked) => filters.value.filterAdmin = checked)
                      }, null, 8, ["checked"])
                    ]),
                    _createVNode(MultiSelect, {
                      options: legendOption.value,
                      label: "Legend",
                      id: "legend",
                      name: "legend",
                      placeholder: "Select..",
                      modelValue: filters.value.filterLegend,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((filters.value.filterLegend) = $event)),
                      searchable: ""
                    }, null, 8, ["options", "modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _createVNode(DataTable, {
              headers: interventionHeaders.value,
              "no-action": false,
              count: items.value.data.length,
              tableClass: "header-frm-table",
              dataTableClass: "border-0"
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value.data, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.id
                  }, [
                    (item.status != 'Done')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                          _createElementVNode("td", _hoisted_31, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["px-3 py-2 text-sm text-white rounded w-max", [item.status == 'Past Due' ? 'bg-red-600' : '', item.status == 'Done' || item.status == 'Scheduled' ? 'bg-green-600' : '']])
                            }, _toDisplayString(item.scheduled_date_formatted), 3)
                          ]),
                          _createElementVNode("td", _hoisted_32, _toDisplayString(item.intervention_type_meta?.description), 1),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(item.type), 1),
                          _createElementVNode("td", _hoisted_34, [
                            _createElementVNode("a", {
                              href: `/patient/${item.cases?.patient_id}/view`,
                              class: "transition cursor-pointer text-primary-600 hover:text-primary-800"
                            }, _toDisplayString(item.cases?.name), 9, _hoisted_35)
                          ]),
                          _createElementVNode("td", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(EditButton, {
                                routeLink: `/patient/${item?.patient_id}/cases/${item?.cases_id}/intervention/${item.intervention_type}/edit/${item.id}`
                              }, null, 8, ["routeLink"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              tfoot: _withCtx(() => [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(SimplePagination, {
                    "show-rows": true,
                    numRows: filters.value.rows ?? 10,
                    currentPage: items.value.current_page,
                    "last-page": items.value.last_page,
                    onUpdate: _cache[18] || (_cache[18] = (value) => paginate(value))
                  }, null, 8, ["numRows", "currentPage", "last-page"])
                ])
              ]),
              _: 1
            }, 8, ["headers", "count"])
          ])
        ])
      ]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})